<xcm-dynamic-form *ngIf="asset" [questions]="questions" (onSave)="onSubmit($event)" (onCancel)="onCancelled()"></xcm-dynamic-form>
